import { HttpModelConverter } from '../../../../../../core/converter/httpModel.converter';
import { Injectable } from '@angular/core';
import { LovValueSummaryConverter } from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import { WorkflowTaskSummaryModel } from '../workflowTaskSummary.model';
import { WorkflowTaskTriggerConverter } from '../../trigger/converter/workflowTaskTrigger.converter';
import { UserSummaryConverter } from '../../../../../../account/modules/user/api/converter/userSummary.converter';
import {
    WorkflowTaskDefinitionConverter
} from '../../../../definition/api/model/converter/workflowTaskDefinition.converter';
import {DateConverter} from '../../../../../../common/converter/date.converter';
import {WorkflowTaskAttributeSummaryConverter} from '../../attribute/converter/workflowTaskAttributeSummary.converter';
import {PartnerSummaryConverter} from '../../../../../../partner/common/api/converter/partnerSummary.converter';
import {MessageConverter} from '../../../../../../message/api/model/converter/message.converter';

@Injectable({
    providedIn: 'root'
})
export class WorkflowTaskSummaryConverter extends HttpModelConverter<WorkflowTaskSummaryModel> {

    constructor(
        private triggerConverter: WorkflowTaskTriggerConverter,
        private workflowTaskDefinitionSummaryConverter: WorkflowTaskDefinitionConverter,
        private lovValueSummaryConverter: LovValueSummaryConverter,
        private workflowTaskAttributeSummaryConverter: WorkflowTaskAttributeSummaryConverter,
        private messageConverter: MessageConverter) {
        super();
    }

    protected createInstance(): WorkflowTaskSummaryModel {
        return new WorkflowTaskSummaryModel();
    }

    protected enrichObject(result: WorkflowTaskSummaryModel, src: WorkflowTaskSummaryModel) {
        result.trigger = this.triggerConverter.convert(src.trigger);
        result.deadline = new DateConverter().convert(src.deadline);
        result.createdAt = new DateConverter().convert(src.createdAt);
        result.executionStart = new DateConverter().convert(src.executionStart);
        result.executionEnd = new DateConverter().convert(src.executionEnd);
        result.assignedUser = new UserSummaryConverter().convert(src.assignedUser);
        result.status = this.lovValueSummaryConverter.convert(src.status);
        result.workflowTaskDefinition = this.workflowTaskDefinitionSummaryConverter.convert(src.workflowTaskDefinition);
        result.publicAttributes = this.workflowTaskAttributeSummaryConverter.convertFromArray(src.publicAttributes);
        result.partner = new PartnerSummaryConverter().convert(src.partner);
    }
}
